<template>
  <b-card>
    <b-row>
      <b-col
          cols="21"
          xl="6"
          class="d-flex justify-content-between flex-column"
      >
        <!-- User Avatar & Action Buttons -->
        <div class="d-flex justify-content-start">
          <UserInfoLogo :is-navabar="false"/>
          <div class="d-flex flex-column ml-1">
            <div class="mb-1">
              <h4 class="mb-0">
                <b-skeleton animation="wave" v-if="data.loadingPerson"/>
                <span v-else>
                  {{data.name}}
                </span>
              </h4>
              <span class="card-text">
                <b-skeleton animation="wave" v-if="data.loadingPerson"/>
                <span v-else>
                  {{data.mail}}
                </span>
              </span>
            </div>
          </div>
        </div>

        <!-- User Stats -->
        <div class="d-flex align-items-center mt-2">
          <div class="d-flex align-items-center mr-2">
            <b-avatar
                variant="light-primary"
                rounded
            >
              <feather-icon
                  icon="DollarSignIcon"
                  size="18"
              />
            </b-avatar>
            <div class="ml-1">
              <h5 class="mb-0">
                <b-skeleton animation="wave" v-if="data.loadingBankSlips"/>
                <span v-else>
                  {{data.lastBankSlipPaidValue}}
                </span>
              </h5>
              <small>Valor boleto (último mês)</small>
            </div>
          </div>

          <div class="d-flex align-items-center">
            <b-avatar
                variant="light-success"
                rounded
            >
              <feather-icon
                  icon="TrendingUpIcon"
                  size="18"
              />
            </b-avatar>
            <div class="ml-1">
              <h5 class="mb-0">
                <b-skeleton animation="wave" v-if="data.loadingUtilization"/>
                <span v-else>
                  {{this.data.totalUtilizationsValue}} (Total de {{this.data.quantityUtilizations}})
                </span>
              </h5>
              <small>Valor utilizações (último mês)</small>
            </div>
          </div>
        </div>
      </b-col>

      <!-- Right Col: Table -->
      <b-col
          cols="12"
          xl="6"
      >
        <table class="mt-2 mt-xl-0 w-100">
          <tr>
            <b-skeleton animation="wave" v-if="data.loadingPerson"/>
            <th class="pb-50" v-else>
              <feather-icon
                  icon="UserIcon"
                  class="mr-75"
              />
              <span class="font-weight-bold">Nome</span>
            </th>
            <td class="pb-50">
              {{data.name}}
            </td>
          </tr>
          <tr>
            <b-skeleton animation="wave" v-if="data.loadingPerson"/>
            <th class="pb-50" v-else>
              <feather-icon
                  icon="CalendarIcon"
                  class="mr-75"
              />
              <span class="font-weight-bold">Data de nascimento</span>
            </th>
            <td class="pb-50">
              {{data.birthDate}}
            </td>
          </tr>
          <tr>
            <b-skeleton animation="wave" v-if="data.loadingPerson"/>
            <th class="pb-50" v-else>
              <feather-icon
                  icon="CreditCardIcon"
                  class="mr-75"
              />
              <span class="font-weight-bold">CPF</span>
            </th>
            <td class="pb-50 text-capitalize">
              {{data.cpf}}
            </td>
          </tr>
          <tr>
            <b-skeleton animation="wave" v-if="data.loadingPerson"/>
            <th class="pb-50" v-else>
              <feather-icon
                  icon="CreditCardIcon"
                  class="mr-75"
              />
              <span class="font-weight-bold">RG</span>
            </th>
            <td class="pb-50 text-capitalize">
              {{data.rg}}
            </td>
          </tr>
          <tr>
            <b-skeleton animation="wave" v-if="data.loadingPerson"/>
            <th class="pb-50" v-else>
              <feather-icon
                  icon="MailIcon"
                  class="mr-75"
              />
              <span class="font-weight-bold">Email</span>
            </th>
            <td class="pb-50">
              {{data.mail}}
            </td>
          </tr>
          <tr>
            <b-skeleton animation="wave" v-if="data.loadingPerson"/>
            <th class="pb-50" v-else>
              <feather-icon
                  icon="CreditCardIcon"
                  class="mr-75"
              />
              <span class="font-weight-bold">Carteirinha</span>
            </th>
            <td>
              {{ data.cart }}
            </td>
          </tr>
        </table>
      </b-col>
    </b-row>
  </b-card>
</template>

<script>
import moment from 'moment';

import ToastificationContent from "@core/components/toastification/ToastificationContent";
import UserInfoLogo from "@/components/UserInfoLogo";

import PersonInfoService from "@/services/PersonInfoService";
import BankSlipService from "@/services/BankSlipService";
import CopartService from "@/services/CopartService";


export default {
  name: "PersonCardInfo",
  components:{
    UserInfoLogo
  },
  mounted() {

    this.getPersonResume();
    this.getBankSlipsPaymentResume();
    this.getUtilizationResumeValue();
  },
  data(){
    return {
      data: {
        name: null,
        email: null,
        birthDate: null,
        rg: null,
        cpf: null,
        mail: null,
        cart: null,
        lastBankSlipPaidValue: 0,
        totalUtilizationsValue: 0,
        quantityUtilizations: 0,
        loadingPerson: false,
        loadingBankSlips: false,
        loadingUtilization: false,
      }
    }
  },
  methods:{
    getPersonResume(){
      this.data.loadingPerson = true;
      PersonInfoService.getInfos().then(resp => {
        this.data.name = resp.data.nome_completo;
        this.data.cpf = resp.data.cpf_cnpj;
        this.data.birthDate = moment(resp.data.data_nascimento).format('DD/MM/YYYY');
        this.data.rg = resp.data.rg;
        this.data.mail = resp.data.contato.toLowerCase();
        this.data.cart = resp.data.num_carteirinha;

        this.data.loadingPerson = false;

      }).catch(err => {
        this.$toast({
              component: ToastificationContent,
              props: {
                title: 'Oops!',
                icon: 'BellIcon',
                text: 'Ocorreu um erro ao buscar os dados do titular.',
                variant: 'danger',
              },
            },
            {
              position: 'top-center'
            })

        this.data.loadingPerson = false;
      });
    },
    getBankSlipsPaymentResume() {
      this.data.loadingBankSlips = true;
      BankSlipService.getLatestBankSlipPaid().then(resp => {
        this.data.lastBankSlipPaidValue = parseFloat(resp.data.valor_boleto).toLocaleString('pt-BR', { minimumFractionDigits: 2 , style: 'currency', currency: 'BRL' })
        this.data.loadingBankSlips = false;
      }).catch(err => {
        this.$toast({
              component: ToastificationContent,
              props: {
                title: 'Oops!',
                icon: 'BellIcon',
                text: 'Ocorreu um erro ao buscar os dados de pagamento.',
                variant: 'danger',
              },
            },
            {
              position: 'top-center'
            })
        this.data.loadingBankSlips = false;
      })
    },
    getUtilizationResumeValue(){
      this.data.loadingUtilization = true;
      CopartService.getUtilizationValue().then(resp => {
        this.data.totalUtilizationsValue = parseFloat(resp.data.total).toLocaleString('pt-BR', { minimumFractionDigits: 2 , style: 'currency', currency: 'BRL' });
        this.data.quantityUtilizations = resp.data.quantity;
        this.data.loadingUtilization = false;
      }).catch(err => {
        this.$toast({
              component: ToastificationContent,
              props: {
                title: 'Oops!',
                icon: 'BellIcon',
                text: 'Ocorreu um erro ao buscar os dados de utilização.',
                variant: 'danger',
              },
            },
            {
              position: 'top-center'
            })
        this.data.loadingUtilization = false;
      })
    }
  }
}
</script>

<style scoped>

</style>